import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

interface ServiceItem {
  title: string;
}

@Component({
  selector: 'app-find-a-service',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './find-a-service.component.html',
  styleUrls: ['./find-a-service.component.css']
})
export class FindAServiceComponent implements OnInit {
  serviceItems: ServiceItem[] = [
    { title: 'TB Diagnosis' },
    { title: 'Emergency Obstetric Care' },
    { title: 'Mother Waiting Shelter' },
    { title: 'Male Circumcision' },
    { title: 'Sexual Health Advice' },
    { title: 'Contraceptive Services' },
    { title: 'HIV Counselling & Testing' },
    { title: 'Prevention of Mother to Child Transmission' },
    { title: 'Delivery Ward' }
  ];

  filteredServiceItems: ServiceItem[] = [];
  searchTerm: string = '';

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.filteredServiceItems = this.serviceItems;
  }

  search(): void {
    if (!this.searchTerm) {
      this.filteredServiceItems = this.serviceItems;
      return;
    }

    this.filteredServiceItems = this.serviceItems.filter(item =>
      item.title.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  getServices(service: string): void {
    this.router.navigate(['/service-provider-list', service]);
  }
}